'use client';

import { useState, type RefObject } from 'react';
import { Button } from '../../Components/Button';
import Modal from '../../Components/Modal';
type HydrationPhase = 'ready' | 'pending' | 'committing' | 'conflict' | 'error';

/** Route-owned composition of existing primitives; no new shared variant or IO. */
export default function OwnedHydrationRecovery({ phase, targetTerm, error, onUseSaved, returnFocusRef }: {
  phase: HydrationPhase; targetTerm: string | null; error: string | null; onUseSaved: () => void; returnFocusRef?: RefObject<HTMLElement | null>;
}) {
  const [reviewing, setReviewing] = useState(false);
  if (phase === 'ready' || phase === 'committing') return null;
  const pending = phase === 'pending';
  return <div className="space-y-2 border-b border-line pb-3 text-content">
    <p role={phase === 'error' ? 'alert' : 'status'} className="text-sm text-content-muted">
      {pending ? `Loading saved changes${targetTerm ? ` · ${targetTerm}` : ''}. Saving is paused.`
        : phase === 'conflict' ? 'Your local version was kept. Saving is paused until you review the saved version.'
          : `${error || 'Saved changes could not be loaded.'} Saving is paused.`}
    </p>
    {!pending && <Button variant="secondary" onClick={() => setReviewing(true)}>Review saved version</Button>}
    <Modal isOpen={reviewing && !pending} onClose={() => setReviewing(false)} title="Use saved version?" size="sm" returnFocusRef={returnFocusRef}>
      <p className="text-sm text-content-muted">This replaces your current local edits with the saved schedule. Your local edits have not been saved.</p>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        <Button variant="secondary" onClick={() => setReviewing(false)}>Not now</Button>
        <Button onClick={() => { setReviewing(false); onUseSaved(); }}>Use saved version</Button>
      </div>
    </Modal>
  </div>;
}
